/**
 * Simple JWT decoder utility
 */

export interface JWTPayload {
  name: string;
  email: string;
  department: string;
  azureId: string;
  role: string;
  exp: number;
  sub: string;
}

/**
 * Decodes a JWT token without external dependencies
 * @param token JWT token string
 * @returns Decoded payload
 */
export function decodeJwt<T>(token: string): T {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    throw new Error('Invalid token format');
  }
}
